import { TextField } from '@material-ui/core';
import styled from 'styled-components';

export const Container = styled.div`
  margin-top: 50px;
  background-color: white;
  border-radius: 4px;
  box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.12);
  display: flex;
  flex-direction: column;
`;

export const CardContainer = styled.div`
  background-color: white;
  display: flex;
  gap: 40px;
  flex-wrap: wrap;
  padding: 16px;
`;

export const StyledTextField = styled(TextField)`
  .MuiInputBase-input.Mui-disabled {
    font-weight: 500;
  }

  .MuiInputLabel-root {
    font-size: 20px;
    font-weight: 500;
    width: 200px;
  }
`;

export const StyledGrid = styled.div`
  position: absolute;
  right: 64px;
  margin-top: 77px;
  height: 50px;
`;
